exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-07e31dce!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/GraveyardOverview.vue
// module id = 359
// module chunks = 0